/**
 * Public façade for the User model. Mirrors the export surface of the
 * original src/app/models/user.js plus the user-domain helpers that
 * used to live in users.service.js / usersRoles.service.js.
 *
 * 75+ consumers across the codebase keep working unchanged because
 * services re-export from here.
 */

export type { IUserDTO, IUserForm, UserRoleCode, UserGroupDTO, UserSchoolDTO } from './user.types';
export type { SelectOption } from '../_shared.types';

export { USER_ROLES, FO } from './user.constants';
export type { UserRoleKey, UserRoleValue } from './user.constants';

export { Model, ModelAdmin } from './user.defaults';

export { ModelYup, ModelYupNotRequired, ModelYupMultiCountry, ModelYupPassword, ModelYupPasswordMultiCountry } from './user.schema';

export { sanitizeData } from './user.sanitize';
export { getDataGeneral, getDataGeneralUpdate } from './user.serialize';
export type { IUserCreateDTO, IUserUpdateDTO } from './user.serialize';

export {
  isTeacher,
  isStudent,
  isAdminEditorial,
  isHelpDesk,
  isPublisher,
  isUserBackOffice,
  canOpenBackofficeSession,
  canSeeFrontOffice,
  isOneclickAccount,
  getUsersBO,
  getUsersFO,
} from './user.role';

export { ModelErrors, ModelSuccess, getModelErrors, getModelSuccess, getRoleText } from './user.messages';

export const MODEL_TEXT = 'user';
